import { useCallback, useState } from "react";
import { ValidationFormErrors, ValidationFormsModeEnum } from "../validation/form/types";

type ValidateFunction<T> = (values: T, mode: ValidationFormsModeEnum, original?: T) => ValidationFormErrors;

export function useFormValidation<T>(validateFn: ValidateFunction<T>) {
  const [errors, setErrors] = useState<ValidationFormErrors>({});

  const validate = useCallback(
    (values: T, mode: ValidationFormsModeEnum = ValidationFormsModeEnum.ADD, original?: T) => {
      const validationErrors = validateFn(values, mode, original);
      const hasErrors = Object.values(validationErrors).some(
        (val) => val && val.trim() !== ""
      );

      setErrors(validationErrors);
      return { hasErrors, validationErrors };
    },
    [validateFn]
  );

  return { errors, validate, setErrors };
}